import { Typography } from '@mui/material'
import { t } from 'i18next'
import theme from 'lib/theme'
import { ExtraProduct } from 'types/model/product'
import { RequiredPill } from './OrderProduct.styled'

export const ProductColPills = ({
  fulfilmentFlags,
  extraProduct,
}: {
  fulfilmentFlags: string[]
  extraProduct: ExtraProduct | undefined
}) => {
  if (!fulfilmentFlags?.length && !extraProduct) return null

  const backgroundColor =
    extraProduct === ExtraProduct.DISCOUNT ||
    extraProduct === ExtraProduct.EXTERNAL_DISCOUNT
      ? theme.palette.error.main
      : theme.palette.text.secondary

  const extraProductTranslation = () => {
    if (extraProduct === ExtraProduct.ACCOUNTING_CHARGE) {
      return t('accountingCharge')
    }
    if (extraProduct === ExtraProduct.EXTERNAL_DISCOUNT) {
      return t('externalDiscount')
    }
    return t(extraProduct?.toLowerCase() ?? '')
  }

  return (
    <>
      {fulfilmentFlags?.map((flag) => (
        <RequiredPill key={flag} sx={extraProduct ? { backgroundColor } : {}}>
          <Typography
            variant='body2'
            fontSize='10px'
            sx={{ color: theme.palette.commonColors.white }}>
            {flag.toUpperCase()}
          </Typography>
        </RequiredPill>
      ))}
      {extraProduct && (
        <RequiredPill sx={{ backgroundColor }}>
          <Typography
            variant='body2'
            fontSize='10px'
            sx={{ color: theme.palette.commonColors.white }}>
            {extraProductTranslation().toUpperCase()}
          </Typography>
        </RequiredPill>
      )}
    </>
  )
}
